import { ContentBlocks } from "@/ui/ContentBlocks";
import cn from "classnames";
import { Accordion, Col, Row } from "react-bootstrap";
import { Buttons } from "src/ui/Buttons";

import classes from "./styles.module.scss";

export default function ({ className, items }) {
  return (
    <Accordion className={cn(className, classes.Accordions)}>
      {items.map((item, idx) => (
        <Accordion.Item eventKey={idx} key={idx}>
          <Accordion.Header as="h3">{item.name}</Accordion.Header>
          <Accordion.Body>
            {typeof item.description === "object" ? (
              <div className="content">{item.description}</div>
            ) : (
              <div className="content" dangerouslySetInnerHTML={{ __html: item.description }} />
            )}
            <Buttons buttons={item.buttons} />
            {Array.isArray(item.images) && (
              <Row>
                {item.images.map((image, i) => (
                  <Col key={i}>{image}</Col>
                ))}
              </Row>
            )}
            {item.children && <ContentBlocks data={item.children} prefix={item.prefix} />}
          </Accordion.Body>
        </Accordion.Item>
      ))}
    </Accordion>
  );
}
